import { z } from 'zod';
import { ComponentType } from '$lib/sanity/types';
import { SanityDocumentSchema, SanityImageObjectSchema } from '../sanity';
import { ImageAssetSchema } from './Image';

export const CarouselSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Carousel),
  name: z.string(),
  caption: z.string().optional(),
  images: z.array(ImageAssetSchema),
  imageRefs: z.array(SanityImageObjectSchema),
  fullWidth: z.boolean().optional()
});

export type Carousel = z.infer<typeof CarouselSchema>;
